import ScreenExpander from '@/assets/images/actionToolbar/screenExpander.svg';
import styles from './screenExpandToggleButton.module.scss';
import useScreenStore from '@/stores/screen';

export default function ScreenExpandToggleButton() {
  const { toggleExpand } = useScreenStore();
  return (
    <button className={styles.screenExpandToggleButton} onClick={toggleExpand}>
      <ScreenExpander />
    </button>
  );
}
